import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon, QpxPill, QpxPillLabel } from '@quipex/shared/ui';
import { resolveColorContext, type ContextFamily } from '@quipex/shared/utils';
import type { QuippySuggestionCategory } from '../../models';
import { CATEGORY_COLOR_CONTEXTS } from '../category-colors';

type CategoryFilter = 'All' | QuippySuggestionCategory;

@Component({
    selector: 'qpx-suggestion-category-filter',
    imports: [MatMenuModule, NgIcon, QpxButton, QpxIcon, QpxPill, QpxPillLabel],
    templateUrl: './suggestion-category-filter.html',
    styleUrl: '../_category-filter.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionCategoryFilter {
    public readonly options = input.required<readonly CategoryFilter[]>();
    public readonly selected = input<CategoryFilter | null>('All');
    public readonly appearance = input<'elevated' | 'outlined'>('elevated');
    public readonly categorySelected = output<CategoryFilter>();
    protected getFilterColorContext(
        category: CategoryFilter | null
    ): ContextFamily {
        return category === null || category === 'All'
            ? 'card'
            : CATEGORY_COLOR_CONTEXTS[category];
    }
    protected getFilterBackground(category: CategoryFilter): string {
        const context = this.getFilterColorContext(category);
        return `var(${resolveColorContext(context, 'muted').surface.variable})`;
    }
    protected getFilterColor(category: CategoryFilter): string {
        const context = this.getFilterColorContext(category);
        return `var(${resolveColorContext(context, 'muted').foreground.variable})`;
    }
}
